import { useTheme } from '@mui/material/styles';
import React, { useContext } from 'react';

import { useMediaQuery } from '@mui/material';

export interface BreakpointsContextData {
    xs: boolean;
    xsDown: boolean;
    sm: boolean;
    md: boolean;
    lg: boolean;
    xl: boolean;
}

const BreakpointsContext = React.createContext<BreakpointsContextData>({
    xs: false,
    xsDown: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
});

export interface BreakpointsProviderParams {
    children: JSX.Element | JSX.Element[];
}

export const useUpBreakpoints = (): BreakpointsContextData =>
    useContext(BreakpointsContext);

export const BreakpointsProvider = ({
    children,
}: BreakpointsProviderParams): JSX.Element => {
    const theme = useTheme();
    const xs = useMediaQuery(theme.breakpoints.up('xs'), { noSsr: true });
    const xsDown = useMediaQuery(theme.breakpoints.down('xs'), { noSsr: true });
    const sm = useMediaQuery(theme.breakpoints.up('sm'), { noSsr: true });
    const md = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });
    const lg = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });
    const xl = useMediaQuery(theme.breakpoints.up('xl'), { noSsr: true });

    return (
        <BreakpointsContext.Provider value={{ xs, xsDown, sm, md, lg, xl }}>
            {children}
        </BreakpointsContext.Provider>
    );
};
